import EventRepository from '@/repositories/EventRepository'
import SnapsnapGateway from '@/gateways/SnapsnapGateway'
import { IEventProps } from '@/entities/Event'

export interface IFetchEventsBySchoolsUseCaseParams {
  eventRepository: EventRepository
  snapsnapGateway: SnapsnapGateway
}

export default class FetchEventsBySchoolsUseCase implements BaseUseCase {
  eventRepository: EventRepository
  snapsnapGateway: SnapsnapGateway

  constructor({ eventRepository, snapsnapGateway }: IFetchEventsBySchoolsUseCaseParams) {
    this.snapsnapGateway = snapsnapGateway
    this.eventRepository = eventRepository
  }

  // 4件ずつに分けて取得する
  async execute(params: { schoolIds: number[] }): Promise<IEventProps[]> {
    try {
      const { schoolIds } = params

      const count = 4
      const chunkLength = Math.ceil(schoolIds.length / count)
      const chunkArray: number[][] = []
      for (let i = 0; i < chunkLength; i++) {
        const startIndex = i * count
        const chunk = schoolIds.slice(startIndex, startIndex + count)
        chunkArray.push(chunk)
      }

      const result = await Promise.all(
        chunkArray.map(async chunk => {
          const events = await this.snapsnapGateway.School.getEventsBySchoolIds({ schoolIds: chunk })
          this.eventRepository.saveEvents(events)
          return events
        })
      )

      // return flatten result
      return result.reduce((acc, ac) => [...acc, ...ac], [] as IEventProps[])
    } catch (error) {
      throw error
    }
  }
}
